import React from "react";
import { Helmet } from "react-helmet";
import { isMobile } from 'react-device-detect';
import withStyles from "@material-ui/core/styles/withStyles";
import Snackbar from '@material-ui/core/Snackbar';

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";

import HeaderPhotoSection from "./Sections/HeaderPhotoSection";
import PaymentMethodsSection from "./Sections/PaymentMethodsSection";
import HotAccommodationsSection from "./Sections/HotAccommodationsSection";
import HotToursSection from "./Sections/HotToursSection";
import FeaturesSection from "./Sections/FeaturesSection";
import KidsAdviceSection from "./Sections/KidsAdviceSection";
import CovidAdviceSection from './Sections/CovidAdviceSection';
import FooterSection from "./Sections/FooterSection";

import CustomNotification from "../LandingPage/Sections/CustomNotification";

import sectionsPageStyle from "../../assets/jss/material-kit-pro-react/views/sectionsPageStyle.jsx";

class LandingPage extends React.Component {
    constructor() {
        super();
        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: ''
        };
    }

    componentDidMount() {
        const { location } = this.props;

        if (!!location.state && !!location.state.message) {
            this.handleClickNotification(location.state.message, location.state.type);
        }

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co" />
                    <meta name="description" content="Descansa en Entornos Rurales, Relájate en el ambiente típico del Campo.
                    Alojamientos, tours y experiencias con los beneficios que brinda el Turismo Rural, Ecoturismo y descanso. Bienvenido" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 130,
                        color: "white"
                    }}
                />
                <div className={classes.main}>
                    {/* Custom Notification */}
                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                    </Snackbar>
                    {/* End Custom Notification */}

                    <HeaderPhotoSection />
                    <CovidAdviceSection />
                    {isMobile
                        ? null
                        : <PaymentMethodsSection />
                    }
                    <HotAccommodationsSection />
                    <HotToursSection />
                    <FeaturesSection />
                    <KidsAdviceSection />
                    <FooterSection />

                    {/*<iframe src="https://www.google.com/maps/embed?pb=!4v1541356200564!6m8!1m7!1sCAoSLEFGMVFpcE9pZkNmTjdoUWppajBmMmVBTm5abUJCdmNBbjl2WXJETVdjRlZX!2m2!1d5.636398199999999!2d-73.5785401!3f83.15730650260728!4f6.266237740781847!5f0.7820865974627469" width="600" height="450" frameborder="0" allowfullscreen></iframe>*/}
                </div>
            </div>
        );
    }
}

export default withStyles(sectionsPageStyle)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx